<template>
  <div class="text-center">
    <h6 v-if="reason != 'number_of_attempts'" class="text-center mb-3">
      <i class="icon-exam"></i>
      Tentativa {{ attempt }}
    </h6>
    <h6 v-if="reason != 'number_of_attempts'">
      Ops! Tente novamente
    </h6>
    <slot>
      <p class="mb-5">
        {{ msg }}
      </p>
    </slot>
    <div class="d-flex justify-content-center">
      <button
        v-if="reason != 'number_of_attempts'"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('retry')"
      >
        <loading small :show="retryLoading">Tentar novamente</loading>
      </button>
      <button
        v-if="reason == 'number_of_attempts'"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('close')"
      >
        Fechar
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    score: {
      type: Object,
      default: () => {}
    },
    result: {
      type: Object,
      default: () => {}
    },
    msg: {
      type: String,
      default: "Tempo esgotado"
    },
    reason: {
      type: String,
      default: ""
    },
    retryLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attempt() {
      if (this.score)
        return `${this.score.number_of_attempts} de ${this.score.quiz.number_of_attempts}`;

      return "";
    }
  }
};
</script>
